import get from "lodash/get";
import {useFormContext} from "react-hook-form";
import {SingleValue} from "react-select";

import {SelectField, SelectFieldBaseProps} from "@/components/form/fields/SelectField/SelectField.tsx";
import ServiceSelect from "@/components/serviceSelect/ServiceSelect.tsx";
import {CheckInfo} from "@/lib/queries/statuspages.ts";

interface ServiceSelectFieldProps extends SelectFieldBaseProps {
  onChange?: (value: SingleValue<CheckInfo>) => void;
  defaultValue?: CheckInfo;
}

export const ServiceSelectField = ({
  name,
  onChange,
  // defaultValue is passed in because one usage uses an id instead of the full object making it impossible to get
  // the default value from dynamic options list without making a backend call which was not implemented.
  defaultValue: propDefaultValue,
  ...rest
}: ServiceSelectFieldProps) => {
  const {
    setValue,
    formState: {defaultValues},
  } = useFormContext();
  const defaultValue = propDefaultValue ?? get(defaultValues, name, undefined);

  return (
    <SelectField
      name={name}
      {...rest}
      select={
        <ServiceSelect
          name={name}
          onChange={(v) => {
            setValue(name, v?.id, {shouldDirty: true, shouldValidate: true});
            if (onChange) {
              onChange(v);
            }
          }}
          defaultValue={defaultValue}
          isClearable={true}
        />
      }
    />
  );
};
